export default "__VITE_ASSET__CAkh8CDx__"